import React from 'react';
import { features } from '../../mock';
import { Scissors, Users, GraduationCap, Star } from 'lucide-react';

const iconMap = {
  0: Scissors,
  1: Users,
  2: GraduationCap,
  3: Star
};

export const FeaturesSection = () => {
  return (
    <section className="py-20 bg-rose-50/30">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold text-stone-900 mb-4">
            Why Choose Us
          </h2>
          <p className="text-lg text-stone-600 max-w-2xl mx-auto">
            Experience the perfect blend of tradition and quality service
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {features.map((feature, index) => {
            const Icon = iconMap[index];
            return (
              <div
                key={feature.id}
                className="group bg-white p-8 rounded-xl border border-stone-200 hover:border-maroon-700 transition-all duration-300 hover:shadow-xl hover:-translate-y-1"
              >
                <div className="bg-maroon-100 w-16 h-16 rounded-lg flex items-center justify-center mb-6 group-hover:bg-maroon-800 transition-colors duration-300">
                  <Icon className="h-8 w-8 text-maroon-800 group-hover:text-stone-100 transition-colors duration-300" />
                </div>
                <h3 className="text-xl font-bold text-stone-900 mb-3">
                  {feature.title}
                </h3>
                <p className="text-stone-600 leading-relaxed">
                  {feature.description}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
